


















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { FileUpload, DataGrid, AlertMessage, PageTitle } from '@questelservices/common-vue';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { DxLoadPanel, DxButton, DxLookup, DxTooltip, DxSelectBox } from 'devextreme-vue';
import { alert as dxAlert } from 'devextreme/ui/dialog';
import {
  DxColumn,
  DxEditing,
  DxSummary,
  DxGroupItem
} from 'devextreme-vue/data-grid';
import FileUploader from 'devextreme/ui/file_uploader';
import CustomStore from 'devextreme/data/custom_store';
import { DxProgressBar } from 'devextreme-vue/progress-bar';
import { ClientService } from '../service/ClientService';
import { AgentService } from '../service/AgentService';
import { FileParseUploadService } from '../service/FileParseUploadService';
import { FileParseUploadResponseDto } from '../models/file-parsing/FileParseUploadResponseDto';
import { FileParseUploadStatusTypeEnum } from '@/models/file-parsing/FileParseUploadStatusTypeEnum';
import { FileParseFormatDto } from '../models/file-parsing/FileParseFormatDto';
import { FileParseFormatColumnDto } from '../models/file-parsing/FileParseFormatColumnDto';
import { FileParseFormatRankingDto } from '../models/file-parsing/FileParseFormatRankingDto';
import { AgentDto } from '../models/agent/AgentDto';
import Lookup from 'devextreme/ui/lookup';
import notify from 'devextreme/ui/notify';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { SelectOption } from '../models/SelectOption';
import { BatchService } from '../service/BatchService';
import String from '@/utilities/String';
import Button from "devextreme/ui/button";
import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import HtmlEditor from "devextreme/ui/html_editor";

@Component({
  components: {
    DataGrid,
    FileUpload,
    AlertMessage,
    DxColumn,
    DxButton,
    DxLoadPanel,
    DxEditing,
    PageTitle,
    DxLookup,
    DxTooltip,
    DxSummary,
    DxGroupItem,
    DxScrollView,
    DxSelectBox,
    DxHtmlEditor,
    DxProgressBar
  }
})
export default class UploadInvoiceFile extends Vue {
  public $refs: Vue['$refs'] & {
    dataGrid?: DataGrid;
    fileUpload?: FileUpload;
    agentLookup?: Lookup;
    submitBtnRef? : Button;
    alertMessageRef? : HtmlEditor;
  } = {};

  private static readonly defaultPageTitle: string = 'Upload Invoice File';

  pageTitle: string = UploadInvoiceFile.defaultPageTitle;
  fileUploadCompleted: boolean = false;
  fileParseComplete: boolean = false;
  fileParseSuccess: boolean = false;
  private fileParseUploadService = new FileParseUploadService();
  cantUploadedFiles: boolean = false;
  percentColumnsUploaded: number = 0;

  get percentUploaded() {
    return this.percentColumnsUploaded * 100;
  }

  fileErrorMessage: string = '';
  dataMessageObjTemp: any = {
    type : "",
    message : ""
  }
  dataMessageObj = this.dataMessageObjTemp;

  @Watch("dataMessageObjTemp") 
  onPropertyChanged(newVal: any, old : any){
    if(newVal) {
        this.dataMessageObj = newVal;
    }
  }
  private filesWithErrors: Set<string> = new Set<string>();
 

  dataGridUrl: string = '';
  dataGridUpdateUrl: string = '';

  submitInProgress: boolean = false;
  submitUrl: string = '';

  fileId: Guid = '';
  fileParseUploadId: Guid = '';
  columns: FileParseFormatColumnDto[] = [];
  rankings: FileParseFormatRankingDto[] = [];

  get submitButton() {
    return ((this.$refs.submitBtnRef as any).instance as any);
  }

  get alertMessage() {
    return ((this.$refs.alertMessageRef as HtmlEditor).instance as any);
  }

  private client = new QuestelServicesClient(this.$store, '');
  private clientService = new ClientService();
  private agentService = new AgentService();
  private batchService = new BatchService();

  clientStore: CustomStore = new CustomStore({
    loadMode: 'raw',
    load: (options): Promise<any> => {
      return this.clientService.getAll();
    }
  });

  selectedClient: Guid = '';
  selectedClientName: string = '';
  selectedAgent: Guid = '';
  selectedAgentName: string = '';
  selectedBatch: Guid = '';
  agentRequired: boolean = false;
  clientBatches: Array<SelectOption> = [];
  selectedRanking: FileParseFormatRankingDto = new FileParseFormatRankingDto();

  get clientSelected() {
    return (
      this.selectedClient !== undefined &&
      this.selectedClient !== null &&
      this.selectedClient !== ''
    );
  }

  get agentSelected() {
    return (
      this.selectedAgent !== undefined && this.selectedAgent !== null && this.selectedAgent !== ''
    );
  }

  private refreshPageTitle() {
    let title = UploadInvoiceFile.defaultPageTitle;
    
    if (!String.isNullOrEmpty(this.selectedClientName)) {
      title += ` for ${this.selectedClientName}`;

      if (!String.isNullOrEmpty(this.selectedAgentName)) {
        title += ` | ${this.selectedAgentName}`;
      }
    }

    this.pageTitle = title;
  }

  private resetPageTitle() {
    this.pageTitle = UploadInvoiceFile.defaultPageTitle;
  }

  private baseUrl: string = '/api';

  constructor() {
    super();
    this.agentStore = this.agentDataSource();
  }

  selectedClientId: Guid | undefined = undefined;
  setSelectedClientId(val: any): void {
    this.selectedClientId = val;
  }

  async onSelectionChanged(e: any) {
    this.setSelectedClientId(e.selectedItem ? e.selectedItem.ClientId : '');
    this.agentStore = this.agentDataSource();

    this.selectedBatch = '';
    if (this.selectedClientId) {
      let batches = await this.batchService.getRecentClientBatches(this.selectedClientId);
      this.clientBatches = batches.map(b => {
        return {
          text: b.BatchName,
          value: b.BatchId
        };
      });
      let openBatch = batches.find(b => b.BatchClosedDate == null);
      this.selectedBatch = openBatch ? openBatch.BatchId : '';
    }
  }

  returnSelectedClientId(): Guid | undefined {
    return this.selectedClientId;
  }

  private agentDataSource(): CustomStore {
    return new CustomStore({      
      loadMode: 'raw',      
      load: (options): Promise<any> => {
        return this.agentService.getAll(this.selectedClientId);
      }
    });
  }

  agentStore: CustomStore = new CustomStore({
    loadMode: 'raw',
    load: (options): Promise<any> => {
      return this.agentService.getAll(this.returnSelectedClientId());
    }
  });

  removeUploadedFilesInSummary() {
    let curr = document.getElementsByClassName('uploaded-files-content')[0];
    curr.innerHTML = '';
  }

  uploadedFilesSummary() {
    setTimeout(() => {
      let uploadedClassname = 'dx-fileuploader-files-container';
      let listOfDownloadedElement = document.getElementsByClassName(uploadedClassname)[0];
      let curr = document.getElementsByClassName('uploaded-files-content')[0];
      curr.appendChild(listOfDownloadedElement);

      this.updateValue(true);
    }, 300);
  }

  updateValue(val: boolean) {
    this.cantUploadedFiles = val;
  }

  getPopupHeight(): number {
    return window.innerHeight / 1.5;
  }

  reset(clearFiles: boolean = false) {
    this.toProcessFiles = [];
    this.fileUploadCompleted = false;
    this.fileParseComplete = false;
    this.fileParseSuccess = false;
    this.cantUploadedFiles = false;
    this.dataMessageObjTemp = {
      type: "",
      message: ""
    }
    this.alertMessage.option("value", this.dataMessageObjTemp.message);
    this.alertMessage.option("visible", this.dataMessageObjTemp.message != '');
    this.dataGridUrl = '';
    this.dataGridUpdateUrl = '';
    this.submitUrl = '';
    this.columns = [];
    this.selectedAgent = '';
    this.agentRequired = false;
    this.removeUploadedFilesInSummary();
    if (clearFiles && this.$refs.fileUpload) {
      let fileUploader = this.$refs.fileUpload as any;
      fileUploader.resetFileUploader();
    }
    this.columns = [];
    this.selectedAgent = '';
    this.filesWithErrors = new Set<string>();
    this.resetPageTitle();
    this.percentColumnsUploaded = 0;
  }

  onDataGridCellPrepared(e: any) {
    if (e.rowType === 'data' && e.data.HasError) {
      let columnData = e.data.Columns.find(
        (c: any) => c.ErrorMessage && c.DataKey === e.column.name
      );
      if (columnData) {
        e.cellElement.classList.add('error');
        e.cellElement.title = columnData.ErrorMessage;
      }
    }
  }

  onUploadStarted(e: any) {
    this.fileErrorMessage = '';
  }

  onUploadError(args: { e: any; fileAuthResult: any }): void {
    // TODO: Do something for these errors.
  }

  onCancelClick() {
    this.deleteUploadData();
    this.reset(true);
  }

  private deleteUploadData(): void {
    if (this.fileParseUploadId) {
      this.client.sendRequest(
        HttpMethodEnum.Delete,
        `/api/FileParseUploads/${this.fileParseUploadId}/data`
      );
    }
  }

  onSubmitClick() {
    this.submitInProgress = true;
    this.client
      .sendRequest(HttpMethodEnum.Patch, this.submitUrl)
      .then(response => {
        this.submitInProgress = false;
        let message = 'Data successfully submitted for processing. Check the File Parse Upload table to see current pending uploads.';
        if (response && response.Message) {
          message = response.Message;
        }
        dxAlert(message, 'Success').then(() => this.reset(true));
      })
      .catch(response => {
        let errorMessage =
          'An error occurred submitting data. Please try again, or contact support if the error continues.';
        if (response && response.Message) {
          errorMessage = response.Message;
        }
        this.dataMessageObjTemp = {
          type: "error",
          message: errorMessage
        }
        this.submitInProgress = false;

        this.alertMessage.option("value", this.dataMessageObjTemp.message);
        this.alertMessage.option("visible", this.dataMessageObjTemp.message != '');
      })
      .finally(() => {
        this.filesWithErrors = new Set<string>();
      });
  }

  onDataGridLoaded(e: any) {
    // Only check for files with errors when loading the group data, and not the data rows
    if(e.data && e.data.some((d: any) => d.summary)) {
      let groupsWithErrors = e.data.filter((d: any) => d.summary[0] > 0);
      if(groupsWithErrors && groupsWithErrors.length) {
        this.filesWithErrors = new Set<string>(groupsWithErrors.map((g: any) => g.key));
      }
    }
  }

  onDataErrorOccurred(e: any) {
    if (e != null && e.error != null) {
      e.error.message = 'An error occurred retrieving the parsed data. Please click Cancel and try again. If the problem persists, please contact support.';
    }
  }

  onOptionChanged(e: any) {
    if(e.name == "value") {
      e.component.$element().removeClass("upload-warning");
      e.component.$element().removeClass("upload-success");
      e.component.$element().removeClass("upload-error");
      if(e.value) {
        if(this.dataMessageObjTemp.type == "success"){
          e.component.$element().addClass("upload-success");
        }
        else if(this.dataMessageObjTemp.type == "warning"){
          e.component.$element().addClass("upload-warning");
        }
        else if(this.dataMessageObjTemp.type == "error") {
          e.component.$element().addClass("upload-error");
        }
      }
    }
  }

  onContentReady(e: any) {
    if (e.component.isReady()) {
      // This is dependent on the order of the summary items.
      // Because the row data is only loaded if the group is expanded, I couldn't find another way to check if the upload is valid.
      let firstRowData = e.component.getVisibleRows() && e.component.getVisibleRows()[0] ? e.component.getVisibleRows()[0].data : undefined;
      if (firstRowData == null) {
        return;
      }
      
      let uploadValid = firstRowData && firstRowData.summary && firstRowData.summary[2] > 0;

      // Disable the submit button if the upload is not valid.
      this.submitButton.option("disabled", !uploadValid)


          if(!uploadValid) {
            
              let dataMessage = 'Invalid and/or missing information detected. Please ensure all required information is present and all data is valid, then upload the file again.';
            
            if (this.filesWithErrors.size > 0) {
              dataMessage = dataMessage + '<br />' + Array.from(this.filesWithErrors).join('<br />');
            }

              this.dataMessageObjTemp = {
                type: "warning",
                message: dataMessage
              }
            
          }
          else {
            this.dataMessageObjTemp = {
                type: "success",
                message: "Data validation succeeded."
              }
          }
        
      
        this.alertMessage.option("value", this.dataMessageObjTemp.message);
        this.alertMessage.option("visible", this.dataMessageObjTemp.message != '');
    }
  } 

  getGroupCellText(data: any) {
    let groupPagingMessage = '';
    if(data.groupContinuedMessage != null) {
      groupPagingMessage += data.groupContinuedMessage;
    }
    if(data.groupContinuesMessage) {
      groupPagingMessage += groupPagingMessage.length > 0
        ? '. ' + data.groupContinuesMessage
        : data.groupContinuesMessage;
    }
    
    let rowCountMessage = '';
    if(data.summaryItems) {
      let totalSummaryItem = data.summaryItems.find((i: any) => i.name === 'TotalRowCount');
      if(totalSummaryItem && totalSummaryItem.value > 0) {
        rowCountMessage += `Total Rows: ${totalSummaryItem.value}`;
      }
      let errorSummaryItem = data.summaryItems.find((i: any) => i.name === 'ErrorRowCount');
      if(errorSummaryItem && errorSummaryItem.value > 0) {
        let errorRowCountMessage = `Rows with error: ${errorSummaryItem.value}`;
        rowCountMessage += rowCountMessage.length > 0
          ? ', ' + errorRowCountMessage
          : errorRowCountMessage;
      }
    }    

    let text = `${data.column.caption}: ${data.text}`;

    if(rowCountMessage.length > 0) {
      text += ` (${rowCountMessage})`;
    }

    if(groupPagingMessage.length > 0) {
      text += ` (${groupPagingMessage})`;
    }

    return text;
  }

  onDataGridRowUpdating(e: any) {
    let modifiedData = e.newData;
    let columnName = Object.keys(modifiedData)[0];
    let data = {
      fileParseUploadDataColumnId: e.oldData.Columns.find((c: any) => c.DataKey === columnName)
        .FileParseUploadDataColumnId,
      newValue: modifiedData[columnName]
    };
    e.newData = data;
  }

  toProcessFiles: any[] = [];
  onUploadComplete(args: { event: any; fileAuthResult: any; totalFiles: number }): void {
    this.refreshPageTitle();

    // Store files that are uploaded
    if (args.fileAuthResult.Files[0]) {
      let file = args.fileAuthResult.Files[0];
      this.toProcessFiles.push(file);
    }

    if (
      args.event.component.option('progress') == 100 &&
      this.toProcessFiles.length === args.totalFiles
    ) {
      var files = this.toProcessFiles.map((x: any) => {
        return {
          FileId: x.FileId,
          Filename: x.FileName
        };
      });

      this.fileUploadCompleted = true;

      this.client
        .getPostData<FileParseUploadResponseDto>('/api/FileParseUploads', {
          files: files,
          clientId: this.selectedClient,
          agentId: this.selectedAgent,
          batchId: this.selectedBatch
        })
        .then(data => {
          //Wait for the upload to complete          
          setTimeout(() => this.waitForUploadToFinish(data.FileParseUploadId), 5000);          
          this.fileParseUploadId = data.FileParseUploadId;
          this.columns = data.Columns;                 
          this.rankings = data.FormatRankings;

          if (this.rankings.length > 0) {
            this.selectedRanking = this.rankings[0];
          }
        })
        .catch(response => {
          this.fileParseComplete = true;
          this.fileParseSuccess = false;
          let errorMessage = 'File parsing failed';
          if (response && response.Message) {
            errorMessage += `: ${response.Message}`;
          }
          this.fileErrorMessage = errorMessage;
        })
        .finally(() => {
          this.uploadedFilesSummary();
        });
    }
  }

  onResubmitClick() {
    this.percentColumnsUploaded = 0;
    this.submitUrl = "";
    this.dataGridUrl = "";
    this.dataGridUpdateUrl = "";                   
    this.fileParseComplete = false;
    this.fileParseSuccess = false; 
    this.dataMessageObjTemp = {
      type: "",
      message: ""
    }
    this.alertMessage.option("value", this.dataMessageObjTemp.message);
    this.alertMessage.option("visible", this.dataMessageObjTemp.message != '');

    this.client.sendRequest(HttpMethodEnum.Delete, `/api/FileParseUploads/${this.fileParseUploadId}/data`)
      .then(_ => {
        var files = this.toProcessFiles.map((x: any)=> {
          return {
            "FileId" : x.FileId,
            "Filename" : x.FileName
          }
        });
        this.client.getPostData<FileParseUploadResponseDto>('/api/FileParseUploads', {
          files: files,
          clientId: this.selectedClient,
          agentId: this.selectedAgent,
          batchId: this.selectedBatch,
          format: this.selectedRanking.Format
        }).then(data => {
          //Wait for the upload to complete          
          setTimeout(() => this.waitForUploadToFinish(data.FileParseUploadId), 5000);          
          this.fileParseUploadId = data.FileParseUploadId;
          this.columns = data.Columns;                      
          dxAlert("File format applied.", 'Success');

        }).catch(response => {
          this.fileParseComplete = true;
          this.fileParseSuccess = false;
          let errorMessage = 'File parsing failed';
          if (response && response.Message) {
            errorMessage += `: ${response.Message}`;
          }
          this.fileErrorMessage = errorMessage;
      });
    });    
  }

  waitForUploadToFinish(fileParseUploadId: Guid) {
    this.fileParseUploadService.get(fileParseUploadId)
      .then(fileParseUpload => {                
        this.percentColumnsUploaded = fileParseUpload.PercentColumnsSaved;

        if (fileParseUpload.StatusType == FileParseUploadStatusTypeEnum.Uploaded) {
          this.submitUrl = `/api/FileParseUploads/${fileParseUpload.FileParseUploadId}`;
          this.dataGridUrl = `/api/FileParseUploads/${fileParseUpload.FileParseUploadId}/data`;
          this.dataGridUpdateUrl = this.dataGridUrl;                   
          this.fileParseComplete = true;
          this.fileParseSuccess = true; 
        }
        else if (fileParseUpload.StatusType == FileParseUploadStatusTypeEnum.TimedOutDuringUpload) {
          let errorMessage = 'File upload timed out while saving parse data';
          this.processUploadError(errorMessage);
        }    
        else if (fileParseUpload.StatusType == FileParseUploadStatusTypeEnum.Failed) {
          let errorMessage = 'An unknown error has occurred while saving parse data.';
          this.processUploadError(errorMessage);
        }
        else {
          // update progress bar
          setTimeout(() => this.waitForUploadToFinish(fileParseUploadId), 5000);
          console.log("Upload hasn't finished yet. Continuing to wait for upload...");
        }        
    });    
  }

  processUploadError(errorMessage: string) {
    this.fileParseComplete = true;
    this.fileParseSuccess = false;    
    this.dataMessageObjTemp = {
      type: "error",
      message: errorMessage
    }
    this.alertMessage.option("value", this.dataMessageObjTemp.message);
    this.alertMessage.option("visible", this.dataMessageObjTemp.message != '');
    this.fileErrorMessage = errorMessage;
  }

  onFileReady(event: any) {
    if (event.value && event.value.length > 0) {
      let fileExtension = event.value[0].name.split('.').pop().toLowerCase();
      if (
        !(event.value as any[]).every((item: any) =>
          item.name
            .split('.')
            .pop()
            .toLowerCase()
            .includes('xls') && fileExtension.includes('xls')
            ? true
            : item.name.split('.').pop().toLowerCase() === fileExtension
        )
      ) {
        notify(
          {
            message: 'All files must be in the same format.',
            position: {
              of: '#invoice-upload',
              at: 'top',
              offset: '0 100'
            }
          },
          'error',
          1500
        );
        event.value = [];
        event.component.option('value', []);
      } else {
        let file: File = event.value[0];
        let ext = file.name.split('.').pop();
        this.agentRequired = ext !== undefined && ext.toLowerCase().indexOf('xls') === -1;
      }
    } else {
      this.agentRequired = false;
    }
  }

  displayFormatRanking(ranking: FileParseFormatRankingDto) {
    if (ranking) {
      return `${ranking.Format.Name} (${(100 * ranking.MatchPercentage).toFixed()}% match,
        ${ranking.MatchedColumns} matched columns, ${ranking.ExtraColumns} extra columns)`;
    } else {
      return '';
    }
  }

  itemTemplate(data: any) {  
    let text = this.displayFormatRanking(data);
    return "<div class='custom-item' title='" + text + "'>" + text + "</div>";  
  }
}
